:host {
  display: block;
}

.pds-tabpanel {
  display: none;
  margin-top: var(--tabs-dimension-panel-margin-top);
  padding: var(--tabs-dimension-panel-padding);

  &:focus-visible {
    outline: var(--pine-outline-focus);
    outline-offset: var(--pine-border-width);
  }

  &.is-active {
    display: block;
  }
}
